/**
* @Author: zachalam
* @Date:   2017-01-26T14:18:52-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-26T14:18:52-08:00
*/

import _ from 'lodash';

let initialState = {
  showTOS: false
};

/* stores logged in profile */
const profile = (state = initialState, action) => {
  switch(action.type) {
    case 'STORE_PROFILE':
      return {
        ...state,
        ...action.payload
      };
    case 'MAKE_PREMIUM':
      return {
        ...state,
        is_premium: true
      }
    case 'STORE_SINGLE_PHOTO':
      // adds one new photo to profile list.
      /*
      var newState = Object.assign({},state);
      newState.photo.data.push(action.payload);
      return newState;*/
      return {
        ...state,
        photo: {
          data: [...state.photo.data,action.payload]
        }
      }
    case 'DELETE_SINGLE_PHOTO':
      // removes a single photo from profile list.
      /*
      var newState = Object.assign({},state);
      _.remove(newState.photo.data, {
          id: action.payload
      });
      return newState;*/
      //console.log(action.payload);
      return {
        ...state,
        photo: {data: _.omit(state.photo.data, action.payload)}
      }
    case 'STORE_DEFAULT_PHOTO':
      //make all avatars false.
      var newPhotoData = _.map(state.photo.data,(v)=>{v.is_avatar = false; return v; });
      // set new default photo.
      newPhotoData[action.payload].is_avatar = true;
      return {
        ...state,
        photo: {data: newPhotoData},
      }
    case 'STORE_NEW_PRIVACY':
      // swaps photo privacy..
      var newPhotoData = _.map(state.photo.data, (v)=>{ return v; });
      newPhotoData[action.payload].private = !newPhotoData[action.payload].private;
      return {
        ...state,
        photo: {data: newPhotoData}
      }
    case 'CANCEL_TRIP_FROM_STORE':
      // removes a selected trip
      return {
        ...state,
        trip: {data: _.omit(state.trip.data, action.payload)}
      }
    case 'SHOW_TOS':
      return {
        ...state,
        showTOS: true
      }

    case 'HIDE_TOS':
      return {
        ...state,
        showTOS: false
      }
    default:
      return state;
  }


}


export default profile;



// WEBPACK FOOTER //
// ./src/reducers/profile.js